var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleHelpDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 147,
    viewBox: "0 0 1439 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 147L1419.97 142.5C1400.02 138 1359.97 129 1320 119C1280.03 109 1239.97 98 1200 92.7C1160.03 87.3 1119.97 87.7 1080 83.8C1040.03 80 999.975 72 960 70C920.025 68 879.975 72 840 75C800.025 78 759.975 80 720 89.7C680.025 99.3 639.975 116.7 600 125.5C560.025 134.3 519.975 134.7 480 130.2C440.025 125.7 399.975 116.3 360 118.5C320.025 120.7 279.975 134.3 240 132.5C200.025 130.7 159.975 113.3 120 110.5C80.025 107.7 39.975 119.3 20.025 125.2L0 131V0H20.025C39.975 0 80.025 0 120 0C159.975 0 200.025 0 240 0C279.975 0 320.025 0 360 0C399.975 0 440.025 0 480 0C519.975 0 560.025 0 600 0C639.975 0 680.025 0 720 0C759.975 0 800.025 0 840 0C879.975 0 920.025 0 960 0C999.975 0 1040.03 0 1080 0C1119.97 0 1160.03 0 1200 0C1239.97 0 1280.03 0 1320 0C1359.97 0 1400.02 0 1419.97 0H1440V147Z",
    fill: "#E6E7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleHelpDown);
export default __webpack_public_path__ + "static/media/articleHelpDown.0a10b365ff13174f02f797cbfb10c6ff.svg";
export { ForwardRef as ReactComponent };